import { createContext } from 'react';

import { FormSections } from 'schema/inquirySchema.models';

export const FormSectionContext = createContext<FormSections | string>(FormSections.root);
